import PropTypes from 'prop-types';
import React from 'react';
import './ErrorWarning.style.scss';

export const ErrorWarning = (props) => {
  return (
    <div className="error-warning">
      <p className="error-warning__text">
        <strong>
          {props.text ||
            'Ops, ocorreu um erro... Por favor, clique no botão ao lado para tentar novamente'}
        </strong>
      </p>

      <button
        id={props.htmlId}
        data-testid={props.htmlId}
        className="error-warning__button"
        onClick={() => props.request()}
      >
        TENTAR NOVAMENTE
      </button>
    </div>
  );
};

ErrorWarning.propTypes = {
  htmlId: PropTypes.string,
  text: PropTypes.string,
  request: PropTypes.func
};
